/**
 * @generated SignedSource<<2cf34f041fb563ccf32b21c355af20dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralsQuery$variables = {};
export type ReferralsQuery$data = {
  readonly referralHistory: {
    readonly " $fragmentSpreads": FragmentRefs<"LifetimeReferralsStats_referralsRef" | "ReferralsMetrics_referralsRef">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReferAFriend_referralsRef">;
};
export type ReferralsQuery = {
  response: ReferralsQuery$data;
  variables: ReferralsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "successes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferralsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralHistory",
        "kind": "LinkedField",
        "name": "referralHistory",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReferralsMetrics_referralsRef"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LifetimeReferralsStats_referralsRef"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ReferAFriend_referralsRef"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ReferralsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReferralHistory",
        "kind": "LinkedField",
        "name": "referralHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReferralsStats",
            "kind": "LinkedField",
            "name": "lifetime",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pending",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyAmount",
                "kind": "LinkedField",
                "name": "earnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subUnitAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReferralsStats",
            "kind": "LinkedField",
            "name": "currentMonth",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referralLink",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08060a2f9eef3fdc27254224aac82178",
    "id": null,
    "metadata": {},
    "name": "ReferralsQuery",
    "operationKind": "query",
    "text": "query ReferralsQuery {\n  referralHistory {\n    ...ReferralsMetrics_referralsRef\n    ...LifetimeReferralsStats_referralsRef\n  }\n  ...ReferAFriend_referralsRef\n}\n\nfragment LifetimeReferralsStats_referralsRef on ReferralHistory {\n  lifetime {\n    successes\n    earnings {\n      subUnitAmount\n      currency\n    }\n  }\n}\n\nfragment ReferAFriend_referralsRef on Query {\n  referralHistory {\n    currentMonth {\n      successes\n    }\n  }\n  referralLink\n}\n\nfragment ReferralsMetrics_referralsRef on ReferralHistory {\n  lifetime {\n    successes\n    pending\n  }\n}\n"
  }
};
})();

(node as any).hash = "10818a666b57db74376f824dbc8f8420";

export default node;
